import { SONIC_TRAIT_SNIPPETS, SONIC_ENERGY_SNIPPETS } from "./snippets.js";
/**
 * Render a SonicTraits object into the prompt snippet injected into the Lyria
 * prompt (spec §4.3). Concatenates the present terms' snippets in the fixed
 * axis order `genres -> era -> timbre -> vibe -> energy`, joined with ", ".
 *
 * `energy: 3` (neutral) and empty/absent axes contribute nothing. `{}` -> "".
 * This is the single point that knows the snippet texts.
 */
export function renderSonicTraits(traits) {
    const parts = [];
    for (const term of traits.genres ?? []) {
        parts.push(SONIC_TRAIT_SNIPPETS.genres[term]);
    }
    if (traits.era !== undefined) {
        parts.push(SONIC_TRAIT_SNIPPETS.era[traits.era]);
    }
    for (const term of traits.timbre ?? []) {
        parts.push(SONIC_TRAIT_SNIPPETS.timbre[term]);
    }
    for (const term of traits.vibe ?? []) {
        parts.push(SONIC_TRAIT_SNIPPETS.vibe[term]);
    }
    if (traits.energy !== undefined) {
        const energySnippet = SONIC_ENERGY_SNIPPETS[traits.energy];
        if (energySnippet)
            parts.push(energySnippet);
    }
    return parts.join(", ");
}
//# sourceMappingURL=render.js.map